import { render, staticRenderFns } from "./MyriadDialog.vue?vue&type=template&id=b5332914&scoped=true&"
import script from "./MyriadDialog.vue?vue&type=script&lang=js&"
export * from "./MyriadDialog.vue?vue&type=script&lang=js&"
import style0 from "./MyriadDialog.vue?vue&type=style&index=0&id=b5332914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.registry.npmjs.org/vue-loader/15.9.8_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5332914",
  null
  
)

export default component.exports